import Events from '@EventEmitter';
import { notificationAudio } from '../../../../../../modules/Dispatch/DispatchChat/ChatSound';
import { TOAST_NOTIFICATION_EVENTS } from '../../../constants';
import type { ToBeReviewedItem } from './buildToBeReviewed';

type DispatchStoreForAlerts = {
  consumeNewToBeReviewedAlertItems?: () => ToBeReviewedItem[];
};

/**
 * Push toast + sound for newly appearing To Be Reviewed notification cards.
 * Call after incremental pickup updates only (not after full addPickups seed).
 * Mirrors driver-message alerts: play sound then emit toast event(s).
 * Skips toast/sound when the bell dropdown is open (items are already visible there).
 */
export const alertNewToBeReviewedPickups = (
  DispatchStore: DispatchStoreForAlerts,
  isNotificationPanelOpen = false
): void => {
  const newItems = DispatchStore.consumeNewToBeReviewedAlertItems?.() || [];
  if (!newItems.length) {
    return;
  }

  if (isNotificationPanelOpen) {
    return;
  }

  notificationAudio.play();
  newItems.forEach((item) => {
    Events.emit(TOAST_NOTIFICATION_EVENTS.showToastPickupReviewNotification, item);
  });
};
